module.exports = __webpack_public_path__ + "img/symbol_2.cd8d6555.png";